var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUexchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0611 23.9456C7.04968 23.9456 2.17676 19.0727 2.17676 13.0612C2.17676 7.04981 7.04968 2.17688 13.0611 2.17688C19.0725 2.17688 23.9455 7.04981 23.9455 13.0612C23.9455 19.0727 19.0725 23.9456 13.0611 23.9456ZM13.0611 9.79593H8.70737V11.9728H18.5033L13.0611 6.53062V9.79593ZM7.61893 14.1497L13.0611 19.5918V16.3265H17.4149V14.1497H7.61893Z",
    fill: "#FFDF80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1224,
    height: 26.1224,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUexchange);
export default __webpack_public_path__ + "static/media/uexchange.c6981690840ec12c0d6bf8577a07a440.svg";
export { ForwardRef as ReactComponent };